defineCustomVueElement('csb-model-selector', {
  name: 'Model Selector',
  template: `<div class="model-selector">
  <div v-if="csbStore.currentModel == null">
    <div v-if="showPicker" class="picker">
      <div class="page-width">
        <div class="row grid grid--2-col">
          <div class="grid__item"><h2>Model Picker</h2></div>
          <div class="grid__item"><p class="align-right"><button @click="showPicker = false" class="picker-button">Close</button></p></div>
        </div>
        <div class="row grid grid--1-col grid--2-col-tablet grid--2-col-desktop">
          <div class="grid__item">
            <h2>Select your brand:</h2>
            <ul>
              <li v-for="(item) in brands" @click="selectBrand(item)" style="cursor: pointer" :class="{ active: item.id == brand, 'option-item': true }"><span class="chainsaw-icon" :class="item.name.toLowerCase()">{{ item.name }}</span></li>
            </ul>
          </div>
          <div class="grid__item" v-if="brand != ''">
            <div class="row grid grid--2-col">
              <div class="grid__item"><h2>Select your {{ this.selectedBrand.name }} model:</h2></div>
              <div class="grid__item"><input class="model-search" v-model="search" placeholder="search models" /></div>
            </div>
            <ul v-if="models.length">
              <li v-for="(model, id) in models" @click="goToCategory(id)" style="cursor: pointer" class="option-item">{{ model.brand + ' ' + model.name }} ({{ model.sub_group.replace(model.brand + ' - ', '') }})</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="not-chosen">
      <div class="model page-width">
    <span class="chainsaw-icon"></span>
    <div class="model-text">
      <strong>FIND PRODUCTS THAT FIT YOUR CHAINSAW</strong>
      <span>select your make and model to view all compatible products</span>
    </div>
    <button class="picker-button" @click="openPicker">start here</button>
  </div>
    </div>
  </div>
  <div v-else class="chosen">
    <div class="model page-width">
      <span class="chainsaw-icon" :class="csbStore.currentModel.brand.toLowerCase()"></span>
      <span>Your chosen model: <a :href="csbStore.currentModel.uri + '?filter.p.m.custom.chain_spec=' + encodeURI(csbStore.currentModel.chain_spec)">{{ csbStore.currentModel.brand + ' ' + csbStore.currentModel.name }}</a></span>
      <span>     
        <span class="collection-icon" :class="csbStore.currentModel.brand.toLowerCase()"><span>{{ csbStore.currentModel.sub_group.toLowerCase().replace(csbStore.currentModel.brand.toLowerCase() + ' - group ', '')[0] }}</span></span>
        <span class="subcollection-icon" :class="csbStore.currentModel.brand.toLowerCase()"><span>{{ csbStore.currentModel.sub_group.toLowerCase().replace(csbStore.currentModel.brand.toLowerCase() + ' - group ', '')[1].toUpperCase() }}</span></span>
      </span>
      <div :class="{ 'show-more': true, show: showMore }">
        <div class="show-more-button" @click="showMore = !showMore"></div>
        <div class="more">
          <a :href="csbStore.currentModel.uri + '?filter.p.m.custom.chain_spec=' + encodeURI(csbStore.currentModel.chain_spec)" class="picker-button">View compatible products</a>
          <button class="picker-button" @click="openPicker">Select new model</button>
          <button class="picker-button" @click="reset">Clear</button>
        </div>
      </div>
    </div>
  </div>
</div>`,
  data() {
    return {
      brand: '',
      model: '',
      search: '',
      showPicker: false,
      showMore: false,
      csbStore: useCsbStore()
    }
  },
  methods: {
    selectBrand(item) {
      this.brand = item.id
      this.search = ''
    },
    goToCategory(id) {
      this.showPicker = false
      var model = this.models[id]
      this.csbStore.currentModel = model
      this.search = ''
      if (model.uri != null && '{{ request.page_type }}' != 'product') {
        window.location = model.uri + '?filter.p.m.custom.chain_spec=' + encodeURI(model.chain_spec);
      }
    },
    openPicker() {
      this.showPicker = true
      this.csbStore.currentModel = null
      this.csbStore.loadGroups()
    },
    reset() {
      this.showPicker = false
      this.csbStore.currentModel = null
    }
  },
  computed: {
    brands() {
      if (this.csbStore.groups.length == 0) {
        return []
      }
      var output = this.csbStore.groups.reduce((result, current) => { if (current.brand.name != 'Universal') { result[current.brand.id] = current.brand; } return result; }, [])
      return Object.values(output).sort((a, b) => {
        var aName = a.name.toLowerCase()
        var bName = b.name.toLowerCase()
        if (aName > bName) {
          return 1
        }
        if (aName < bName) {
          return -1
        }
        return 0
      })
    },
    selectedBrand() {
      if (this.brand == '') {
        return null
      }
      return this.brands.find(item => item.id == this.brand)
    },
    models() {       
      if (this.brand == '') {
        return [];
      } else {
        var output = this.csbStore.groups.filter(i => i.brand.id == this.brand).reduce((result, current) => { 
          var collection_uri = null;
          if (current.collection != null) {
            collection_uri = current.collection.uri
          }
          if (this.search == '') {
            Array.prototype.push.apply(result, current.models.map(m => { return { name: m, uri: collection_uri, sub_group: current.name, group: current.group, brand: current.brand.name, brand_id: current.brand.id, chain_spec: current.chain_spec }}))
          } else {
            Array.prototype.push.apply(result, current.models.filter(m => m.toLowerCase().includes(this.search.toLowerCase())).map(m => { return { name: m, uri: collection_uri, sub_group: current.name, group: current.group, brand: current.brand.name, brand_id: current.brand.id, chain_spec: current.chain_spec }}))
          }
          return result
        }, [])
        if (output.length == 0) {
          return [];
        }
        return Object.values(output).sort((a, b) => {
          var aName = a.name.toLowerCase()
          var bName = b.name.toLowerCase()
          if (aName > bName) {
            return 1
          }
          if (aName < bName) {
            return -1
          }
          return 0
        })
      }
    }
  },
  async mounted() {
    await this.csbStore.init()
  }
}, { plugins: [ piniaStore ] })